import { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import './Navigation.css';

function Navigation() {
    const [scrolled, setScrolled] = useState(false);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        element.scrollIntoView({ behavior: 'smooth' });
        setExpanded(false); // Close navbar after clicking
    };

    return (
        <Navbar
            expand="lg"
            fixed="top"
            className={scrolled ? 'scrolled' : ''}
            expanded={expanded}
            onToggle={(expanded) => setExpanded(expanded)}
        >
            <Container>
                <Navbar.Brand
                    onClick={() => {
                        scrollToSection('home');
                        setExpanded(false);
                    }}
                    className="brand"
                >
                    <span className="brand-name">Arges Expres</span>
                    <span className="brand-sub">Imobiliare TI&LU</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="nav-links ms-auto">
                        <Nav.Link onClick={() => scrollToSection('home')}>Acasă</Nav.Link>
                        <Nav.Link onClick={() => scrollToSection('about')}>Despre Noi</Nav.Link>
                        <Nav.Link onClick={() => scrollToSection('services')}>Servicii</Nav.Link>
                        <Nav.Link onClick={() => scrollToSection('contact')}>Contact</Nav.Link>
                    </Nav>
                    <Nav.Link
                        href="https://dashboard.aipro.ro/start/46467501"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="login-button"
                    >
                        Autentificare
                    </Nav.Link>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Navigation;